import { Component } from '@angular/core';
import { LoaderScreenService } from 'src/app/service/loader-screen/loader-screen.service';

@Component({
  selector: 'app-loader-screen',
  templateUrl: './loader-screen.component.html',
  styleUrls: ['./loader-screen.component.scss'],
})
export class LoaderScreenComponent {
  constructor(public loaderScreen: LoaderScreenService) {}
}
